import {createGlobalStyle} from 'styled-components';


const GlobalStyle = createGlobalStyle`
  :root {
    --purple-primary: #554DDE;
    --accent-pink: #F44E77;
    --neutral-light: #e2fbdf;
    --lavender-secondary: #6A6D9E;
    --dark-primary: #16194F;
    --border-colour: #CAD6F1;
  }

  * {
    margin: 0;
    padding: 0;
    list-style: none;
    box-sizing: border-box;
    font-family: 'Nunito', sans-serif;
    text-decoration: none;
  }

 body {
  font-size: 1.2rem;
  color: white;
  background: linear-gradient(270deg, #a8e6cf, #56ab2f, #a3e635, #379683);
  background-size: 800% 800%;
  animation: gradientBackground 20s ease infinite;
}

@keyframes gradientBackground {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

`;


export default GlobalStyle;